module.exports = __webpack_public_path__ + "media/topSection/top-section-1-2920cef0.png";